@if (form) {
  <div [formGroup]="form">
    <!-- WCAG 1.3.1 — label for/id; 1.3.5 — roster name is not personal-name autocomplete -->
    <div class="form-group" appParentValidator [control]="form.controls.name">
      <div class="app-input" [class.disabled]="isExternalWithoutSourceId">
        <label for="name">{{ 'NAME' | translate }}</label>
        <input
          type="text"
          formControlName="name"
          class="form-control"
          id="name"
          autocomplete="off"
          [readonly]="isExternalWithoutSourceId"
          [attr.aria-invalid]="hasVisibleError('name') ? 'true' : null"
          [attr.aria-describedby]="hasVisibleError('name') ? 'roster-settings-err-name' : null"
          />
      </div>
      <app-form-error [control]="form.controls.name" errorElementId="roster-settings-err-name"></app-form-error>
    </div>
    <!-- Source ID -->
    @if (sourceIdValue) {
      <div class="form-group">
        <div class="app-input disabled">
          <label for="sourceId">{{ 'SOURCE_ID' | translate }}</label>
          <input type="text" [value]="sourceIdValue" class="form-control" id="sourceId" readonly autocomplete="off" />
        </div>
      </div>
    }
    <!-- Description — unique id + labelledby for Axe/AT (avoid generic id="description" collisions) -->
    <div class="input-form-group form-group" appParentValidator [control]="form.controls.description">
      <div class="app-input">
        <label id="roster-general-settings-description-lbl" for="roster-general-settings-description">{{
          'DESCRIPTION' | translate
        }}</label>
        <textarea
          formControlName="description"
          class="form-control"
          id="roster-general-settings-description"
          rows="5"
          autocomplete="off"
          [attr.aria-labelledby]="'roster-general-settings-description-lbl'"
          [attr.aria-invalid]="hasVisibleError('description') ? 'true' : null"
        [attr.aria-describedby]="
          hasVisibleError('description') ? 'roster-settings-err-description' : null
        "
          >
        </textarea>
      </div>
      <app-form-error [control]="form.controls.description" errorElementId="roster-settings-err-description"></app-form-error>
    </div>
    <!-- Type of roster -->
    <div class="input-form-group form-group" appParentValidator [control]="form.controls.type">
      <app-roster-type-select [className]="'app-input'" [form]="form"> </app-roster-type-select>
      <app-form-error [control]="form.controls.type" errorElementId="roster-settings-err-type"></app-form-error>
    </div>
    <!-- Access type management -->
    <div [hidden]="typeValue !== rosterType.Shared">
      <app-roster-adults-select [form]="form"> </app-roster-adults-select>
    </div>
    <!-- Status -->
    <div class="form-group pt-2">
      <app-status-checkbox [form]="form"> </app-status-checkbox>
    </div>
  </div>
}
